export const stateData = {
    day: "",
    tows: [],
    canClose: false,
    canReopen: false,
    canDownloadPdf : false,
    onCloseMessage : null,
    onCloseMessageChange : false,
    flyDayCloseInProgress: false,

    currentUser: null,
    /** Dokud není ověřen token (/user/me), uživatel není považován za přihlášeného — jinak by se vykreslil FlyDay bez přihlášení. */
    isAuthenticated: false,
    /** Po dokončení /user/me — teprve pak smí router přesměrovat na login. */
    authCheckComplete: false,
    isLoading: false,

    filterPilot: null,
    filterGlider: null,
    filterTowingPlane: null,
    filterTowingPilot: null,
    incompleteFilter: false,

    active : {
        reel: false,
        first: null,
        second: null,
        lifter: null,
        glider: null,
        towTask: null,
        towingPlane: null,
        flyDay: null
    },

    flyDay: null,
    flyDayStompConnectionStatus : false,
    infoData: null,

    /** Neplatné dokumenty kluzáků — jednou za běh aplikace (Redux), FlyDay jen načte / aktualizuje. */
    gliderDocInvalidity: {
        initialized: false,
        dismissed: false,
        rows: []
    }
};